import { render } from "./ParcelsView.vue?vue&type=template&id=6ac4f529"
import script from "./ParcelsView.vue?vue&type=script&lang=js"
export * from "./ParcelsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__